import React from 'react';
import SecondaryNav from './SecondaryNav';
import { Upload, TrendingUp, RefreshCw, Store, PackageCheck } from 'lucide-react';

const ManageStockLayout = ({ currentView, children }) => {
  const manageStockNavItems = [
    { view: 'uploadInvoice', label: 'Upload Invoice', icon: Upload },
    { view: 'indentEstimate', label: 'Indent Estimate', icon: TrendingUp },
    { view: 'shiftTransfer', label: 'Stock Transfer', icon: RefreshCw },
    { view: 'addStore', label: 'Add Store', icon: Store },
    { view: 'stockReceived', label: 'Stock Received', icon: PackageCheck }
  ];

  return (
    <>
      <SecondaryNav 
        items={manageStockNavItems}
        currentView={currentView}
      />

      {children}
    </>
  );
};

export default ManageStockLayout;

